const refactoComarquage = () => {
	const comarguage = document.getElementById('comarquage') || null;
	if (comarguage) {
		const clears = comarguage.querySelectorAll('.co-clearfix');
		clears.forEach(clear => { clear.remove() })
	}
}

refactoComarquage();

